var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50001 41.8333H29.5C29.8708 41.8333 30.225 41.7708 30.5667 41.6791L22.7354 33.8479C21.0367 34.9795 19.0411 35.5833 17 35.5833C11.2563 35.5833 6.58334 30.9104 6.58334 25.1666C6.58334 19.4229 11.2563 14.75 17 14.75C22.7438 14.75 27.4167 19.4229 27.4167 25.1666C27.4169 27.2078 26.8131 29.2034 25.6813 30.902L33.5125 38.7333C33.6042 38.3916 33.6667 38.0375 33.6667 37.6666V12.6666L21.1667 0.166626H4.50001C3.39494 0.166626 2.33513 0.605613 1.55373 1.38701C0.77233 2.16842 0.333344 3.22822 0.333344 4.33329V37.6666C0.333344 38.7717 0.77233 39.8315 1.55373 40.6129C2.33513 41.3943 3.39494 41.8333 4.50001 41.8333Z",
    fill: "#B3995B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/Find.2ff37884fe7924a343b7de9e9fe3db38.svg";
export { ForwardRef as ReactComponent };